export const newFolderForm = {
  dirName: '',
  userId: '',
  parentId: ''
};
